import { render } from "./DateCalculator.vue?vue&type=template&id=c0b4e7d6&scoped=true"
import script from "./DateCalculator.vue?vue&type=script&lang=js"
export * from "./DateCalculator.vue?vue&type=script&lang=js"

import "./DateCalculator.vue?vue&type=style&index=0&id=c0b4e7d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b4e7d6"]])

export default __exports__